module.exports = __webpack_public_path__ + "img/eshoy_slider_btn_label.442e8477.png";